export function createFulfilledPrepare() {
  return result => ({
    payload: result
  });
}